/* eslint-disable no-dupe-keys */
export default {
  feedback: {
    name: '意见反馈',
    // 属性（一般与对象内容匹配）
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      content: '反馈内容',
      genre: '反馈类型',
      user_id: '用户',
      read: '阅读状态',
      processed: '处理状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    genres: {
      opinion: '意见',
      error: '错误',
      help: '帮助'
    },
    // Boolean的属性
    reads: { true: '已读', false: '未读' },
    processeds: { true: '已处理', false: '待处理' },
    // 占位提示
    placeholder: {
      search_keyword: '查询反馈内容'
    },
    // 详情页标签
    tips: {
      process_confirm: '确定当前用户反馈已经处理?'
    },
    btn: {
      read: '标记已读',
      process: '标记已处理',
      pending_process: '未处理',
      processed: '已处理'
    },
    list_tabs: {
      all: '全部',
      unread: '未读',
      unprocessed: '未解决'
    }
  }
}
